<template>
  <v-card v-if="(isDriblab && currentUser.showMediaMode) || (!isDriblab)" class="mb-2" elevation="0" outlined>
    <v-card-title class="pa-2 body-1">
      <div class="d-flex justify-space-between w-100 align-center">
        <span class="body-1 primary--text">{{$t("general.mediaMode")}}</span>
        <v-switch color="secondary"
          v-model="_mediaMode"
          label
          hide-details
          class="mt-n1"
          @change="onMediaModeChange()"
        ></v-switch>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text v-if="_mediaMode && !selectorMode" class="py-0 px-0 d-flex flex-column flex-wrap align-start justify-space-between" style="overflow:auto;">
      <div :class="`d-flex flex-column w-${fieldSize}`" v-for="(field,index) of fields" :key="index" >
        <div class="d-flex flex-column px-2 py-1">
          <div
            class="d-flex justify-space-between align-center cursor-pointer"
            @click="_mediaModeFlags[field.key] = !_mediaModeFlags[field.key]"
          >
            <span>{{$t(field.label,field.labelParams)}}</span>
            <v-icon
              v-if="field.type != 'switch'"
            >{{_mediaModeFlags[field.key] ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            <v-switch color="secondary"
              v-if="field.type === 'switch'"
              v-model="_mediaModeData[field.key]"
              label
              hide-details
              class="mt-n1"
              dense
            ></v-switch>
          </div>
          <v-expand-transition>
            <div class="d-flex justify-center" v-if="field.type === 'text'">
              <v-text-field
                dense outlined
                hide-details
                v-model="_mediaModeData[field.key]"
                v-show="_mediaModeFlags[field.key]"
                class="py-0 slim-input"
                @keydown.enter="onMediaControlsChange()"
                @blur="onMediaControlsChange()"
              ></v-text-field>
            </div>
            <div class="d-flex justify-center" v-if="field.type === 'number'">
              <v-text-field
                dense outlined
                hide-details
                type="number"
                v-model="_mediaModeData[field.key]"
                v-show="_mediaModeFlags[field.key]"
                class="py-0 slim-input"
                @keydown.enter="onMediaControlsChange()"
                @blur="onMediaControlsChange()"
              ></v-text-field>
            </div>
            <div class="d-flex justify-center" v-if="field.type === 'color'">
              <v-color-picker
                dot-size="25"
                mode="hexa"
                v-model="_mediaModeData[field.key]"
                v-show="_mediaModeFlags[field.key]"
                canvas-height="75"
                class="py-0"
                :hide-inputs="false"
                @update:color="onMediaControlsChange()"
              ></v-color-picker>
            </div>
            <div class="d-flex justify-center w-100" v-if="field.type === 'radio'">
              <v-radio-group
                v-show="_mediaModeFlags[field.key]"
                v-model="_mediaModeData[field.key]"
                @change="onMediaControlsChange()"
                class="my-1"
                hide-details
                mandatory
                row
              >
                <v-radio color="secondary"
                  :label="$t(option.label)"
                  :value="option.value"
                  v-for="(option,index) of field.options"
                  :key="index"
                >
                  <template v-slot:label>
                    <span class="body-1 primary--text">{{ $t(option.label) }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
            <div class="d-flex flex-column w-100"  v-if="field.type === 'image'" v-show="_mediaModeFlags[field.key]" >
              <div class="file-selector w-100 mb-5">
                <v-file-input
                  v-show="_mediaModeFlags[field.key]"
                  prepend-icon
                  prepend-inner-icon="$file"
                  hide-details
                  flat
                  solo
                  dense
                  height="25px"
                  :placeholder="$t('general.uploadFile')"
                  @change="onFileChange($event,field)"
                ></v-file-input>
              </div>
              <cropper v-if="field.type === 'image' && _mediaModeData[field.key].src && _mediaModeFlags[field.key]" ref="cropper"
              :src="_mediaModeData[field.key].src" :defaultPosition="_mediaModeData[field.key].defaultPosition"  :defaultSize="_mediaModeData[field.key].defaultSize"
              @change="onCropperChange($event,field)" :debounce="100"
              :stencil-size="{
                width: 300,
                height: 300
              }" :stencil-props="{aspectRatio:1,movable:false,resizable:false,handlers:{}}"
              imageRestriction="stencil" defaultBoundaries="fill" style="height:320px"></cropper>
            </div>
          </v-expand-transition>
        </div>
        <v-divider></v-divider>
      </div>
    </v-card-text>
    <v-card-text v-if="_mediaMode && selectorMode" class="py-0 px-0 d-flex flex-column flex-wrap align-start justify-space-between" style="overflow:auto;">
      <div class="d-flex w-100 pa-2 mb-2">
        <v-autocomplete :items="fields" return-object
            v-model="selectedField" dense hide-details
            item-value="key" color="secondary"
            :placeholder="$t('mediaMode.selectField')"
            filled class="slim-input body-1 primary--text font-weight-bold"
            auto-select-first>
          <template v-slot:selection="{item}">
            <span>{{$t(item.label,item.labelParams)}}</span>
          </template>
          <template v-slot:item="{item}">
            <span>{{$t(item.label,item.labelParams)}}</span>
          </template>
        </v-autocomplete>
      </div>
      <div class="d-flex px-2 pb-2 w-100" v-if="selectedField">
        <div class="d-flex justify-center align-center w-100" v-if="selectedField.type === 'switch'">
          <span
                class="mr-2 v-label cursor-pointer primary--text body-1"
                @click="_mediaModeData[selectedField.key]=!_mediaModeData[selectedField.key];onMediaControlsChange()"
              >{{$t("general.disabled")}}</span>
          <v-switch color="secondary"
            v-model="_mediaModeData[selectedField.key]"
            @change="onMediaControlsChange()"
            :label="$t('general.enabled')"
            hide-details
            class="mt-n1"
            dense
          >
            <template v-slot:label>
              <span class="body-1 primary--text">{{ $t('general.enabled') }}</span>
            </template>
          </v-switch>
        </div>
        <div class="d-flex justify-center" v-if="selectedField.type === 'text'">
          <v-text-field
            dense outlined
            hide-details
            v-model="_mediaModeData[selectedField.key]"
            class="py-0 slim-input"
            @keydown.enter="onMediaControlsChange()"
            @blur="onMediaControlsChange()"
          ></v-text-field>
        </div>
        <div class="d-flex justify-center" v-if="selectedField.type === 'number'">
          <v-text-field
            dense outlined
            hide-details
            type="number"
            v-model="_mediaModeData[selectedField.key]"
            class="py-0 slim-input"
            @keydown.enter="onMediaControlsChange()"
            @blur="onMediaControlsChange()"
          ></v-text-field>
        </div>
        <div class="d-flex justify-center w-100" v-if="selectedField.type === 'color'">
          <v-color-picker
            dot-size="25"
            mode="hexa"
            v-model="_mediaModeData[selectedField.key]"
            canvas-height="75"
            class="py-0"
            :hide-inputs="false"
            @update:color="onMediaControlsChange()"
          ></v-color-picker>
        </div>
        <div class="d-flex justify-center w-100" v-if="selectedField.type === 'radio'">
          <v-radio-group
            v-model="_mediaModeData[selectedField.key]"
            @change="onMediaControlsChange()"
            class="my-1"
            hide-details
            mandatory
            row
          >
            <v-radio color="secondary"
              :label="$t(option.label)"
              :value="option.value"
              v-for="(option,index) of selectedField.options"
              :key="index"
            >
              <template v-slot:label>
                <span class="body-1 primary--text">{{ $t(option.label) }}</span>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
        <div class="d-flex justify-center w-100" v-if="selectedField.type === 'select-multiple'">
          <v-select
            v-model="_mediaModeData[selectedField.key]"
            @change="onMediaControlsChange()"
            class="my-1 slim-input"
            hide-details
            multiple outlined
            :items="selectedField.options"
          >
          </v-select>
        </div>
        <div class="d-flex justify-center w-100" v-if="selectedField.type === 'select'">
          <v-autocomplete
            v-model="_mediaModeData[selectedField.key]"
            @change="onMediaControlsChange()"
            class="my-1 slim-input"
            hide-details outlined
            :item-text="selectedField.itemText"
            :item-value="selectedField.itemValue"
            :return-object="selectedField.returnObject"
            :items="selectedField.options"
            :placeholder="$t(selectedField.placeholder)"
          >
          </v-autocomplete>
        </div>
        <div class="d-flex flex-column w-100"  v-if="selectedField.type === 'image'"  >
          <div class="file-selector w-100 mb-5">
            <v-file-input
              prepend-icon
              prepend-inner-icon="$file"
              hide-details
              flat
              solo
              dense
              height="25px"
              :placeholder="$t('general.uploadFile')"
              @change="onFileChange($event,selectedField)"
            ></v-file-input>
          </div>
          <cropper v-if="selectedField.type === 'image' && _mediaModeData[selectedField.key].src" ref="cropper"
          :src="_mediaModeData[selectedField.key].src" :defaultPosition="_mediaModeData[selectedField.key].defaultPosition"  :defaultSize="_mediaModeData[selectedField.key].defaultSize"
          @change="onCropperChange($event,selectedField)" :debounce="100"
          :stencil-size="selectedField.stencilSize ? null : {
            width: 300,
            height: 300
          }" :stencil-props="{aspectRatio:selectedField.aspectRatio || 1,movable:false,resizable:selectedField.resizable || false,handlers:{}}"
          :imageRestriction="selectedField.imageRestriction || 'stencil'" defaultBoundaries="fill" style="height:320px" @error="onCropperError($event,selectedField)"></cropper>
        </div>
      </div>
    </v-card-text>
    <v-divider v-if="_mediaMode && showButtons"></v-divider>
    <v-card-actions class="d-flex justify-end pt-2 mt-0" v-if="_mediaMode && showButtons">
      <v-btn
        color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
        :x-small="!$vuetify.breakpoint.xsOnly"
        v-on:click.native="saveAsPNG()"
      >
        <v-icon small class="mr-1">
          file_download</v-icon
        >
        <span class="">PNG</span>
      </v-btn>
      <v-btn
        color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small
        :x-small="!$vuetify.breakpoint.xsOnly"
        v-on:click.native="saveAsSVG()"
      >
        <v-icon small
          >file_download</v-icon
        >
        <span>SVG</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { Cropper } from 'vue-advanced-cropper';
import {getDataUrl} from '../../utils/functions';
export default {
  name: "MediaModeForm",
  components:{
    Cropper
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    mediaMode: {
      type: Boolean,
      required: false
    },
    mediaModeFlags: {
      type: Object,
      required: false
    },
    mediaModeData: {
      type: Object,
      required: false
    },
    fieldSize: {
      type: Number,
      default: 100
    },
    selectorMode: {
      type: Boolean,
      default: false
    },
    showButtons: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isDriblab(){
      return this.currentUser.clientId == 30;
    },
    _mediaMode: {
      get: function() {
        return this.mediaMode;
      },
      set: function(value) {
        this.$emit("mediaModeChange", value);
      }
    },
    _mediaModeData: {
      get: function() {
        return this.mediaModeData;
      },
      set: function(value) {
        this.$emit("mediaModeDataChange", value);
      }
    },
    _mediaModeFlags: {
      get: function() {
        return this.mediaModeFlags;
      },
      set: function(value) {
        this.$emit("mediaModeFlags", value);
      }
    }
  },
  data() {
    return {
      selectedField: null
    };
  },
  watch: {
    "fields": function(newVal, oldVal) {
    }
  },
  mounted(){
    
  },
  methods: {
    onMediaModeChange() {
    },
    onMediaControlsChange() {
      if(this.selectedField){
        this._mediaModeData.force = this.selectedField.force;
      }
      this.$emit("mediaModeDataChange", this._mediaModeData);
    },
    loadImage(targetField,img){
      let base_image = new Image();
      base_image.crossOrigin = "anonymous";
      base_image.src = img;
      base_image.onload = (event) => {
        const dataUrl = getDataUrl(event.currentTarget);
        this._mediaModeData[targetField.key].dataUrl = dataUrl;
        _.forEach(this.fields,(f) => {
          if(f.key === targetField.key){
            f.loaded = true;
          }
        })
      }
    },
    prepareFields(){
      _.forEach(this.fields,(f) => {
        if(f.type === "image" && this._mediaModeData[f.key] && !f.loaded){
          this.loadImage(f,this._mediaModeData[f.key])
        }
      })
    },
    onCropperChange(event,targetField){
      if(event && event.canvas && event.visibleArea){
        this._mediaModeData[targetField.key].dataUrl = event.canvas.toDataURL("image/png");
        this._mediaModeData[targetField.key].defaultPosition = { left:event.coordinates.left,top:event.coordinates.top };
        this._mediaModeData[targetField.key].defaultSize = { width:event.coordinates.width,height:event.coordinates.height };
        this.onMediaControlsChange();
        this.$forceUpdate();
      }
    },
    onFileChange(e,targetField){
      const file = e;
      if (file.type.indexOf('image/') === -1) {
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this._mediaModeData[targetField.key].src = event.target.result;
          let result;
          if(this.selectorMode){
            this.$refs['cropper'].refresh();
            result = this.$refs['cropper'].getResult()
          }else{
            this.$refs['cropper'][0].refresh();
            result = this.$refs['cropper'][0].getResult();
          }
          this.onCropperChange(result,targetField);
        };
        reader.readAsDataURL(file);
      }
    },
    saveAsPNG() {
      this.$emit("buttonClicked","PNG")
    },
    saveAsSVG() {
      this.$emit("buttonClicked","SVG")
    },
    onCropperError(event,targetField){
      this._mediaModeData[targetField.key].src = this._mediaModeData[targetField.key].fallBackSrc;
      this.$forceUpdate();
    }

  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/base/MediaModeForm.vue